import { Heading } from '@strata/react-page-templates';
import { type ReactNode } from 'react';

interface OverviewProps {
    title: string;
    description: string;
    image: string;
    content: ReactNode;
}

export const Overview = ({ title, description, image, content }: OverviewProps) => (
    <div className="sds_overview__page">
        <div className="sds_overview__primary-container">
            <div className="margin__right--xx-large">
                <Heading text={title} />
                <div className="sds_overview__description">{description}</div>
            </div>
            <img className="sds_overview__image" src={image} alt="Overview" loading="lazy" />
        </div>
        {content}
    </div>
);
